import Text from '@mui/material/Typography'

function Fees() {
   return (
      <div>
         <div style={{marginTop:10, marginBottom:100}}><Text variant='h6'>Fees & Charges</Text></div>
      </div>
   )
}
export default Fees